<template>
  <div class="row mt-4">
    <div class="col-md-6 border-right mb-3">
      <h5>Perfiles Disponibles</h5>
      <div class="d-flex align-items-center justify-content-end">
        <b-form-input
          v-model="searchInVacantProfiles"
          class="d-inline-block mr-1"
          placeholder="Filtrar..."
          data-cy="search-vacant-profile"
        />
      </div>
    </div>
    <div class="col-md-6 border-right mb-3">
      <h5>Perfiles Asignados</h5>
      <div class="d-flex align-items-center justify-content-end">
        <b-form-input
          v-model="searchInAsignedProfiles"
          class="d-inline-block mr-1"
          placeholder="Filtrar..."
          data-cy="search-asigned-profile"
        />
      </div>
    </div>
    <!-- RESULTADOS -->
    <div class="col-md-6 border-right">
      <vs-list class="box-users">
        <div v-for="role in filteredAvailableProfiles" :key="role.idPerfil">
          <vs-list-item
            :title="role.nombre"
            v-tooltip="role.descripcion"
          >
            <vs-button
              v-if="!userProfiles[role.idPerfil]"
              color="warning"
              size="small"
              type="border"
              v-on:click.once="addProfile(role)"
              data-cy="add-permission"
            >
              Agregar
            </vs-button>
          </vs-list-item>
        </div>
        <div v-show="loading">
          <b-skeleton animation="fade" width="70%"/>
          <b-skeleton animation="fade" width="80%"/>
          <b-skeleton animation="fade" width="60%"/>
          <b-skeleton animation="fade" width="85%"/>
          <b-skeleton animation="fade" width="70%"/>
        </div>
      </vs-list>
    </div>
    <div class="col-md-6">
      <vs-list class="box-users">
        <div
        v-for="role in filteredUserProfiles"
        :key="role.idPerfil"
        data-cy="remove-permission"
        >
          <vs-list-item
            v-tooltip="role.descripcion"
            :title="role.nombre"
          >
            <vs-button
              color="danger"
              size="small"
              type="border"
              icon="highlight_off"
              v-on:click.once="removeProfile(role)"
              data-cy="remove-permission"
            />
          </vs-list-item>
        </div>
        <div v-show="loading">
          <b-skeleton animation="fade" width="70%"/>
          <b-skeleton animation="fade" width="80%"/>
          <b-skeleton animation="fade" width="60%"/>
          <b-skeleton animation="fade" width="85%"/>
          <b-skeleton animation="fade" width="70%"/>
        </div>
      </vs-list>
    </div>
  </div>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

import {
  ioAddProfileToUser,
  ioRemoveProfileToUser,
  ioCompanyGetAccessProfiles,
  ioGetUserProfiles
} from '@/febos/servicios/api/v2.companies.api';

export default {
  mixins: [],
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      searchInVacantProfiles: '',
      searchInAsignedProfiles: '',
      rolesList: {},
      loading: false,
      writing: false,
      userProfiles: []
    };
  },
  watch: {
  },
  computed: {
    ...mapGetters('Usuario', [
      'currentUser'
    ]),
    ...mapGetters('Management', [
      'companyProfiles'
    ]),
    ...mapGetters('Empresas', [
      'company'
    ]),
    filteredAvailableProfiles() {
      if (this.searchInVacantProfiles !== '') {
        return Object.values(this.rolesList)
          .filter(
            (rol) => rol.nombre.toLowerCase()
              .indexOf(this.searchInVacantProfiles.toLowerCase()) > -1
          );
      }
      return this.rolesList;
    },
    filteredUserProfiles() {
      if (this.searchInAsignedProfiles !== '') {
        return Object.values(this.userProfiles)
          .filter(
            (rol) => rol.nombre.toLowerCase()
              .indexOf(this.searchInAsignedProfiles.toLowerCase()) > -1
          );
      }
      return this.userProfiles;
    }
  },
  methods: {
    ...mapActions('Management', [
      'getCompanyAccessProfiles'
    ]),
    async loadProfilesList() {
      this.loading = true;
      const response = await ioCompanyGetAccessProfiles({
        empresaId: this.company.id
      });
      const list = response.data.perfiles.reduce((accumulator, profile) => ({
        ...accumulator,
        [profile.idPerfil]: { ...profile },
      }), {});
      this.rolesList = list;
      this.loading = false;
    },
    async addProfile(profile) {
      this.loading = true;
      try {
        await ioAddProfileToUser({
          empresaId: this.company.id,
          usuarioId: this.user.id,
          perfilId: profile.idPerfil
        });
        this.loading = false;
        this.$bvToast.toast(
          'Se ha agregado el perfil exitosamente',
          {
            title: '¡Genial!',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 4000,
          }
        );
        await this.loadProfilesList();
        await this.getUserProfiles();
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },
    async removeProfile(profile) {
      this.loading = true;
      try {
        await ioRemoveProfileToUser({
          empresaId: this.company.id,
          usuarioId: this.user.id,
          perfilId: profile.idPerfil
        });
        this.loading = false;
        this.$bvToast.toast(
          'Se ha removido el perfil exitosamente',
          {
            title: '¡Genial!',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 4000,
          }
        );
        await this.loadProfilesList();
        await this.getUserProfiles();
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },
    async getUserProfiles() {
      const response = await ioGetUserProfiles({
        empresaId: this.company.id,
        usuarioId: this.user.id
      });
      const list = response.data.perfiles.reduce((accumulator, profile) => ({
        ...accumulator,
        [profile.idPerfil]: { ...profile },
      }), {});
      this.userProfiles = list;
      this.loading = false;
    }
  },
  mounted() {
    this.loading = false;
    this.writing = false;
    this.loadProfilesList();
    this.getUserProfiles();
  }
};
</script>
<style scoped>

.box-users {
  height: 500px;
  overflow-y: auto;
}
.con-vs-popup .vs-popup {
  width: 70% !important;
}
.exists {
  color: #671e85;
  background: #671e852b;
  border-radius: 4px;
  margin-top: 2px;
}
</style>
